import * as React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import { FormFieldComponentProps } from '../../../lib/types/types';
import { setRef } from '../../../lib/refs/refs';

interface PassedProps {
    explanation?: string | JSX.Element;
    onKeyDown?: Function;
}

const EmailComponent = ({
    value,
    isErrored,
    onChange,
    explanation,
    onKeyDown = undefined,
    placeholder = '',
}: FormFieldComponentProps & PassedProps) => {
    return (
        <div className="sid-field sid-email">
            <div className="sid-l-space-top-md" />
            <label htmlFor="sid-email">
                <div className={`sid-field__label-with-explanation sid-l-space-btm-sm ${placeholder ? 'sid-h-screen-reader-only' : ''}`}>
                    <div className="sid-field__label sid-field__label--required">
                        <FormattedHTMLMessage
                            id="emailAddress"
                            defaultMessage="Email address"
                        />
                    </div>
                    <div className="sid-field__label-explanation">
                        {
                            explanation ? explanation :
                                <FormattedHTMLMessage
                                    id="emailExplanation"
                                    defaultMessage="Needed to send you your unique code"
                                />
                        }
                    </div>
                </div>
            </label>
                <input
                    className={
                        `sid-text-input sid-text-input--required
                            sid-l-full-width ${isErrored ? 'sid-text-input--error' : ''}`
                    }
                    id="sid-email"
                    name="sid-email"
                    type="email"
                    value={value}
                    onChange={e => onChange(e.target.value)}
                    onKeyDown={typeof onKeyDown === 'function' ? e => onKeyDown(e) : undefined}
                    placeholder={placeholder}
                    ref={input => setRef('email', input)}
                />

            {
                isErrored ? (
                    <div className="sid-field-error">
                        <FormattedHTMLMessage
                            id="errorId.invalidEmail"
                            defaultMessage="Invalid email"
                        />
                    </div>
                ) : null
            }
        </div>
    );
};

export {  EmailComponent };
